<app-titled-page heading="Usuarios">
  <router-outlet></router-outlet>
</app-titled-page>
